import { render, staticRenderFns } from "./UpdateCurrency.vue?vue&type=template&id=31a7ab1e&scoped=true"
import script from "./UpdateCurrency.vue?vue&type=script&lang=js"
export * from "./UpdateCurrency.vue?vue&type=script&lang=js"
import style0 from "./UpdateCurrency.vue?vue&type=style&index=0&id=31a7ab1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a7ab1e",
  null
  
)

export default component.exports